// Type definitions for certificates & agreements: label, fields, and print body.
export const CERT_TYPES = {
  dealer: {
    label: "Dealer / Distributor Authorization",
    fields: [
      { key: "authorized_for", label: "Authorized For (products/range)" },
      { key: "territory", label: "Territory / Area" },
      { key: "valid_till", label: "Valid Till", type: "date" },
    ],
    body: (d, c) => `This is to certify that ${d.party_name}${d.party_address ? `, ${d.party_address}` : ""} is an authorized Dealer / Distributor of ${c.legal_name || c.name} for ${d.authorized_for || "our product range"} in the territory of ${d.territory || "the assigned area"}. This authorization is valid till ${fmt(d.valid_till)}.`,
  },
  c_and_f: {
    label: "C&F Agent Authorization",
    fields: [
      { key: "warehouse_location", label: "Warehouse / Depot Location" },
      { key: "territory", label: "Territory" },
      { key: "valid_till", label: "Valid Till", type: "date" },
    ],
    body: (d, c) => `This certifies that ${d.party_name} is appointed as the Carrying & Forwarding (C&F) Agent of ${c.legal_name || c.name} operating from ${d.warehouse_location || "the designated depot"} covering ${d.territory || "the assigned territory"}. Valid till ${fmt(d.valid_till)}.`,
  },
  medical_shop: {
    label: "Medical Shop Authorization",
    fields: [
      { key: "drug_license_no", label: "Drug License No." },
      { key: "valid_till", label: "Valid Till", type: "date" },
    ],
    body: (d, c) => `This is to certify that ${d.party_name}${d.party_address ? `, ${d.party_address}` : ""} (Drug License No. ${d.drug_license_no || "—"}) is an authorized medical shop / retail partner of ${c.legal_name || c.name}. Valid till ${fmt(d.valid_till)}.`,
  },
};

export const AGR_TYPES = {
  employee: {
    label: "Employee Agreement",
    fields: [
      { key: "designation", label: "Designation" },
      { key: "joining_date", label: "Joining Date", type: "date" },
      { key: "salary", label: "Monthly Salary (₹)" },
      { key: "duration", label: "Term / Duration" },
    ],
    body: (d, c) => `This Employment Agreement is made between ${c.legal_name || c.name} ("Employer") and ${d.party_name} ("Employee") for the position of ${d.designation || "—"}, joining on ${fmt(d.joining_date)} at a monthly salary of ₹${d.salary || "—"}. The term of employment is ${d.duration || "as per company policy"}. The Employee agrees to abide by the Employer's policies, confidentiality and code of conduct.`,
  },
  dealer: {
    label: "Dealer Agreement",
    fields: [
      { key: "territory", label: "Territory" },
      { key: "products", label: "Product Range" },
      { key: "commission_pct", label: "Margin / Commission %" },
      { key: "duration", label: "Term / Duration" },
    ],
    body: (d, c) => `This Dealer Agreement is entered into between ${c.legal_name || c.name} ("Company") and ${d.party_name} ("Dealer") for the distribution of ${d.products || "the Company's products"} in ${d.territory || "the assigned territory"} at a margin/commission of ${d.commission_pct || "—"}%. The agreement is valid for ${d.duration || "one year"} and is renewable by mutual consent.`,
  },
  c_and_f: {
    label: "C&F Agreement",
    fields: [
      { key: "warehouse_location", label: "Warehouse Location" },
      { key: "territory", label: "Territory" },
      { key: "commission_pct", label: "Service Fee %" },
      { key: "duration", label: "Term / Duration" },
    ],
    body: (d, c) => `This Carrying & Forwarding Agreement is between ${c.legal_name || c.name} ("Company") and ${d.party_name} ("C&F Agent") for stocking and forwarding goods from ${d.warehouse_location || "the depot"} across ${d.territory || "the territory"} at a service fee of ${d.commission_pct || "—"}%. Term: ${d.duration || "one year"}.`,
  },
  medical_shop_sale: {
    label: "Medical Shop Sale Agreement",
    fields: [
      { key: "credit_limit", label: "Credit Limit (₹)" },
      { key: "payment_terms", label: "Payment Terms" },
      { key: "duration", label: "Term / Duration" },
    ],
    body: (d, c) => `This Sale Agreement is between ${c.legal_name || c.name} ("Supplier") and ${d.party_name} ("Retailer") for the supply of pharmaceutical products on a credit limit of ₹${d.credit_limit || "—"} with payment terms of ${d.payment_terms || "as agreed"}. Term: ${d.duration || "one year"}.`,
  },
  manufacturing: {
    label: "Manufacturing Agreement",
    fields: [
      { key: "product_scope", label: "Products / Scope" },
      { key: "moq", label: "Minimum Order Qty" },
      { key: "payment_terms", label: "Payment Terms" },
      { key: "duration", label: "Term / Duration" },
    ],
    body: (d, c) => `This Manufacturing Agreement is entered into between ${c.legal_name || c.name} ("Principal") and ${d.party_name} ("Manufacturer") for the manufacture of ${d.product_scope || "the specified products"} at a minimum order quantity of ${d.moq || "—"}, with payment terms of ${d.payment_terms || "as agreed"}. Term: ${d.duration || "one year"}, renewable on mutual agreement.`,
  },
};

export function fmt(v) {
  if (!v) return "—";
  try { return new Date(v).toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" }); }
  catch (e) { return v; }
}
